export { default } from "./DeliveryFromLeafly";
